import { createSlice } from "@reduxjs/toolkit"

import { setAPIHealthHandler } from "./healthActionHandlers"
import { HealthReducerState } from "./types"

const initialState: HealthReducerState = {
  endpointHealth: {
    projects: true,
    price: true,
    productConfiguration: true,
    productInformation: true
  }
}

const healthSlice = createSlice({
  name: "health",
  initialState,
  reducers: {
    setAPIHealth: setAPIHealthHandler
  }
})

export const { setAPIHealth } = healthSlice.actions

export const healthActions = healthSlice.actions

export default healthSlice.reducer
